import { RsiTile } from 'widgets/signalTiles/rsiTile/components/RsiTile';
import { rsiTileDescription } from 'widgets/signalTiles/rsiTile/components/description/rsiTileDescription';
import {
    buildSignalTileWidgetStrategy,
    SignalTileWidgetStrategyOptions,
} from 'widgets/signalTiles/signalTile/SignalTileWidgetStrategy';
import { WidgetType } from 'widgets/WidgetType';
import {
    rsiConfigSlice,
    rsiStreamedDataSelectors,
} from 'widgets/signalTiles/rsiTile/state';
import { RsiTileMyPortfolioCapsuleContent } from 'widgets/signalTiles/rsiTile/components/RsiTileMyPortfolioCapsuleContent';

const { useStreamedDataMessages } = rsiStreamedDataSelectors;

const options: SignalTileWidgetStrategyOptions = {
    title: 'RSI',
    reactComponentType: RsiTile,
    description: rsiTileDescription,
    widgetType: WidgetType.RSI_TILE,
    startChannelDestination: 'startRsiStream',
    configSlice: rsiConfigSlice,
    myPortfolioCapsuleContentReactComponentType:
        RsiTileMyPortfolioCapsuleContent,
    useStreamedDataMessages,
};

export const rsiTileWidgetStrategy = buildSignalTileWidgetStrategy(options);
